import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import PublicProfileComponent from './components/PublicProfileComponent';

const PublicProfile = () => {
  return renderComponent(<PublicProfileComponent />);
};

export default PublicProfile;
